import CallFetchAPI from "./CallFetchAPI";
import RedirectToCorrectPage from "./RedirectToCorrectPage";

export default function WhenToggleDatabaseCode(scoutingMarks, databaseOn, databaseCode, navigate, dispatch) {
    if (databaseCode === undefined) return

    RedirectToCorrectPage(databaseOn, databaseCode, navigate).then()

    CallFetchAPI(scoutingMarks, databaseOn, databaseCode, dispatch).then()
}